// controls the swiper for missing / incomplete products at the cart
// needs to be in its own class to make it reactive

import Swiper from 'swiper';

class SwiperMissingOffer extends HTMLElement {
  constructor() {
    super();

    this.render();
  }

  render() {
    new Swiper('.cart__offers-box', {
      slidesPerView: 1,
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
}

customElements.define('swiper-missing-offer', SwiperMissingOffer);

export default SwiperMissingOffer;
